import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggedInUser, UserCourseProgressWithModules } from 'src/app/models';
import { AuthService } from 'src/app/services/auth.service';
import { CoursesService } from 'src/app/services/courses.service';

@Component({
  selector: 'app-rentwise',
  templateUrl: './rentwise.component.html',
  styleUrls: ['./rentwise.component.css']
})
export class RentwiseComponent implements OnInit {

  constructor(public coursesService: CoursesService, private auth: AuthService, private router: Router, private route: ActivatedRoute) { }

  user!: LoggedInUser;
  progress: number = 0;
  outerColor: string = '';
  innerColor: string = '';
  agency: any = {};

  get course() { return this.coursesService.currentCourse as UserCourseProgressWithModules; }
  get modules() { return this.course.modules; }

  ngOnInit(): void {
    this.user = this.auth.user || {};

    this.coursesService.setCurrentCourseBy('RentWise');

    // Load progress and color
    this.progress = this.course.courseID !== 'RentWise' ? this.course.fheProgress || 0 : this.course.rentwiseProgress || 0;

    // Low progress
    if (this.progress <= 20) {
      this.outerColor = '#FC051A';
      this.innerColor = '#f57687';
    }

    // Medium progress
    if (this.progress > 20 && this.progress < 60) {
      this.outerColor = '#FFEA00';
      this.innerColor = '#FFFF8F';
    }

    // High progress
    if (this.progress >= 60) {
      this.outerColor = '#008000';
      this.innerColor = '#50C878';
    }

    // Set agency
    this.agency = this.coursesService.rentWiseAgency;
  }

  // Continue course
  async continueCourse() {

    // Pre-evaluation not complete
    if (this.course.preTestRequired && !this.course.preTestPassed)
      return this.router.navigate([`./pre-evaluation`], { relativeTo: this.route });

    // Course not complete, go to last module
    if (this.course.furthestModuleID < this.modules.length)
      return this.router.navigate(['./m', this.course.furthestModuleID + 1], { relativeTo: this.route });

    // Course complete, go to post-evaluation survey
    if (this.course.postTestRequired && !this.course.postTestPassed)
      return this.router.navigate([`./post-evaluation`], { relativeTo: this.route });

    // Course and post-evaluation complete, go to certificate
    if (this.course.furthestModuleID >= this.modules.length && this.user.ageUnder18 === true)
      return this.router.navigate([`./certificate`], { relativeTo: this.route });

    // Course complete, go to properties
    if (this.course.furthestModuleID >= this.modules.length && this.user.ageUnder18 !== true)
      return this.router.navigate([`./properties`], { relativeTo: this.route });

    return false;
  }
}
